var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('loading'),_c('notifications'),_c('header-cna'),_c('router-view'),_c('footer-cna')],1)}
var staticRenderFns = []

export { render, staticRenderFns }